import request from "@/utils/request";

export default {
  queryQspiPerformance: (pageNum, pageSize, type, quarter, month, year) => {
    return request({
      url: `/qspiPerformance?pageNum=${pageNum}&pageSize=${pageSize}&type=${type}&quarter=${quarter}&month=${month}&year=${year}`,
      method: "get",
    });
  },
  getbySupplier: (pageNum, pageSize, type, quarter, month, year) => {
    return request({
      url: `/qspiPerformance/bySupplier?pageNum=${pageNum}&pageSize=${pageSize}&type=${type}&quarter=${quarter}&month=${month}&year=${year}`,
      method: "get",
    });
  },
  getSummary: (pageNum, pageSize, type, quarter, month, year) => {
    return request({
      url: `/qspiPerformance/summary?pageNum=${pageNum}&pageSize=${pageSize}&type=${type}&quarter=${quarter}&month=${month}&year=${year}`,
      method: "get",
    });
  },
  exportQspiFspi: (pageNum, pageSize, type, quarter, month, year) => {
    return request({
      url: `/qspiPerformance/export?pageNum=${pageNum}&pageSize=${pageSize}&type=${type}&quarter=${quarter}&month=${month}&year=${year}`,
      method: "get",
      responseType: "blob",
      fullResponse: true,
    });
  },
  queryPage: (param) => {
    return request({
      url: `/qspi/report/overallPerformance/queryPage`,
      method: "post",
      data: param,
    });
  },
  queryQspiMonthlyAnalysis: (ratingPeriod, peerRatingPeriod) => {
    return request({
      url: `/qspiMonthlyAnalysis?ratingPeriod=${ratingPeriod}&peerRatingPeriod=${peerRatingPeriod}`,
      method: "get",
    });
  },
  getQspiMonthlyTbleLabel: (factorType, ratingPeriod) => {
    return request({
      url: `/qspiMonthlyAnalysis/factorDesc/${factorType}/${ratingPeriod}`,
      method: "get",
    });
  },
  rebackYearsForSelector: () => {
    return request({
      url: `/qspi/report/overallPerformance/rebackYearsForSelector`,
      data: {},
      method: "post",
    });
  },

  exportQspiMonthlyAnalysis: (ratingPeriod, peerRatingPeriod) => {
    return request({
      url: `/qspiMonthlyAnalysis/export?ratingPeriod=${ratingPeriod}&peerRatingPeriod=${peerRatingPeriod}`,
      method: "get",
      responseType: "blob",
      fullResponse: true,
    });
  },
  exportOverallPerformance: (param) => {
    return request({
      url: `/qspi/report/overallPerformance/exportOverallPerformance`,
      method: "post",
      data: param,
      responseType: "blob",
      fullResponse: true,
    });
  },
};
